import { useCallback, useEffect, useState } from 'react';
import { useUserContext } from 'UserContext';
import { FeatureFlag, useFeatureFlag } from 'shared';
import UserAttributesApi from 'shared/UserAttributesApi';

export const FLORIDA_CLEARINGHOUSE_POLICY_ATTRIBUTE = 'Florida Clearinghouse Policy Agreed';

export function useFloridaClearinghousePolicy() {
    const { user } = useUserContext();
    const { featureActive, featuresLoaded } = useFeatureFlag(FeatureFlag.FLORIDA_CLEARINGHOUSE_MANUAL_CHECK);
    const [agreed, setAgreed] = useState<boolean>();

    const isFloridaCenter = user?.address?.some((address) => address.state === 'Florida') ?? false;
    const policyApplies = featuresLoaded && featureActive && isFloridaCenter && !user?.admin;

    useEffect(() => {
        if (!policyApplies) return;

        let current = true;
        UserAttributesApi.exists(FLORIDA_CLEARINGHOUSE_POLICY_ATTRIBUTE)
            .then((exists) => current && setAgreed(exists))
            .catch(() => current && setAgreed(true));
        return () => {
            current = false;
        };
    }, [policyApplies, user?.id]);

    const agreeToPolicy = useCallback(
        () => UserAttributesApi.create(FLORIDA_CLEARINGHOUSE_POLICY_ATTRIBUTE).then(() => setAgreed(true)),
        [],
    );

    return { showPolicyModal: policyApplies && agreed === false, agreeToPolicy };
}
